module.exports = __webpack_public_path__ + "static/media/courier_open_door_tips.5132929.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/CESite40s/mp3/courier_open_door_tips.mp3
// module id = cluP
// module chunks = 1